export default __webpack_public_path__ + "static/media/touchZero.e5d98f5d.svg";